import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import View from 'view/base';

export default View.extend({
    className: 'project-name-inline-edit',

    events: {
        'click .project-name'   : 'onEditProjectName',
        'blur .project-name'    : 'onSubmitProjectName',
        'keydown .project-name' : 'onProjectNameKeydown',
        'keyup .project-name'   : 'onProjectNameKeyup'
    },

    dom_handlers: {
        onEditProjectName: function(e) {
            $(e.currentTarget).prop('contenteditable', true).focus();
        },

        onProjectNameKeydown: function(e) {
            // no line break
            if (e.which && e.which === 13) {
                e.preventDefault();
            }
        },

        onProjectNameKeyup: function(e) {
            // submit on enter key
            if (e.which && e.which === 13) {
                this.$el.find('.project-name').blur();
                this.save();
            }
        },

        onSubmitProjectName: function(e) {
            $(e.currentTarget)
                .prop('contenteditable', false)
                .scrollLeft(0);

            this.save();
        }
    },

    save: function() {
        var project_name = this.$el.find('.project-name').text().trim();

        if (!project_name) {
            return;
        }

        Cache.app.request({
            action: 'project/update',
            data: {
                project_id: Cache.default_project_id,
                name: project_name
            },
            success: () => {
                this.model.set('name', project_name);
                UI.success('Project name updated');
            }
        });
    },

    render: function() {
        var content =
        (this.model.get('logo') ?
        '<span class="project-logo-icon" style="background-image:url(' + this.model.escape('logo') + ');"></span>' :
        '<span class="project-type-icon" data-val="' + (this.model.isFeedback() ? 'feedback' : 'survey') + '"></span>') +
        '<span class="project-name">' + this.model.escape('name') + '</span>';

        this.$el.html(content);

        return this;
    }
});